import ItineraryPriceLoader, {
    type ItineraryPriceLoaderFactory,
    type PriceObject,
} from '../ItineraryPriceLoader';

export default abstract class TripPriceLoader extends ItineraryPriceLoader {
    constructor({ priceTypeCode, ...other }: TripPriceLoaderFactory) {
        super(other);
        this.priceTypeCode = priceTypeCode;
    }

    protected readonly priceTypeCode?: string;

    abstract override fetchSinglePrices(
        fromDate: Date,
        toDate: Date,
        origin: string,
        destination: string
    ): Promise<PriceObject[]>;

    override equals(other: TripPriceLoader): boolean {
        return (
            super.equals(other) && other.priceTypeCode === this.priceTypeCode
        );
    }
}

export type TripPriceLoaderFactory = Omit<
    ItineraryPriceLoaderFactory,
    'roomCount'
> & {
    priceTypeCode?: string;
};
